import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ChevronRightOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_72)'>
        <path
          d='M10.4999 17.0001C10.3683 17.0008 10.2379 16.9756 10.116 16.9258C9.9942 16.8761 9.88338 16.8027 9.78994 16.7101C9.69621 16.6171 9.62182 16.5065 9.57105 16.3846C9.52028 16.2628 9.49414 16.1321 9.49414 16.0001C9.49414 15.868 9.52028 15.7373 9.57105 15.6155C9.62182 15.4936 9.69621 15.383 9.78994 15.2901L13.0999 12.0001L9.91994 8.69005C9.73369 8.50269 9.62915 8.24924 9.62915 7.98505C9.62915 7.72087 9.73369 7.46741 9.91994 7.28005C10.0129 7.18632 10.1235 7.11193 10.2454 7.06116C10.3672 7.01039 10.4979 6.98425 10.6299 6.98425C10.762 6.98425 10.8927 7.01039 11.0145 7.06116C11.1364 7.11193 11.247 7.18632 11.3399 7.28005L15.1999 11.2801C15.3832 11.467 15.4858 11.7183 15.4858 11.9801C15.4858 12.2418 15.3832 12.4931 15.1999 12.6801L11.1999 16.6801C11.1102 16.777 11.0021 16.8552 10.882 16.9101C10.7618 16.965 10.632 16.9956 10.4999 17.0001Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_72'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
